module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0144.jpg?v=f67f80fe";